import { Card } from "../../models/card";
export class Magic extends Card {
}
Magic.displayName = "Magic";
Magic.artUrl = "./assets/cards/magic.jpg";
